import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import model from '../../QuickAppointmentPage/viewModel'
import ProductAndServicesQuoteFieldComponent from './ProductAndServicesQuoteFieldComponent'

const BOTProductAndServicesQuote = ({
  activeVehicle,
  hasActiveVehicle,
  handleAddNewVehicle,
  ...props
}) =>
  <Fragment>
    <Field
      { ...props }
      { ...model.storeSelector }
      component={ ProductAndServicesQuoteFieldComponent } />
  </Fragment>

export default BOTProductAndServicesQuote

BOTProductAndServicesQuote.propTypes = {
  activeVehicle: PropTypes.shape(),
  handleAddNewVehicle: PropTypes.func,
  hasActiveVehicle: PropTypes.bool,
  icon: PropTypes.string,
  title: PropTypes.string
}
